import RATING from "./rating";

const ColorValues = {
  [RATING.GOOD]: "#54AF34",
  [RATING.AVERAGE]: "#F3A45C",
  [RATING.BAD]: "#F35C5C",
};

export default ColorValues;
